export default __webpack_public_path__ + "static/media/499.7f45499c.png";